import React, { useEffect, useState, useRef } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import Menu from "../../comum/Menu/menu.jsx";
import Footer from "../../comum/Footer/index.jsx";
import { api } from '../../services/api.js';
import Swal from 'sweetalert2';

// =========================
// COMPONENTE FOTO (SUB-RECURSO)
// =========================
const FotoItem = ({ idItem, tipoFoto, titulo, onZoom, isEditable, onFileSelect }) => {
   const [foto, setFoto] = useState(null);
   const [loading, setLoading] = useState(true);
   const fileInputRef = useRef(null);

   useEffect(() => {
      const carregarFoto = async () => {
         try {
            const res = await api.get(`/vistoria/foto/${idItem}`);
            if (res.data && res.data.length > 0) {
               const dados = res.data[0];
               setFoto(tipoFoto === 'antes' ? dados.foto_antes : dados.foto_depois);
            }
         } catch (e) {
            console.error("Erro ao carregar foto:", e);
         } finally {
            setLoading(false);
         }
      };
      carregarFoto();
   }, [idItem, tipoFoto]);

   const handleClick = () => {
      if (isEditable && !foto) {
         fileInputRef.current.click();
      } else if (foto) {
         onZoom(`data:image/jpeg;base64,${foto}`);
      }
   };

   return (
      <div className="text-center">
         <label style={{ fontSize: '10px', fontWeight: 'bold' }} className="text-muted d-block mb-1">
            {titulo}
         </label>
         <div
            className="rounded border bg-light d-flex align-items-center justify-content-center shadow-sm"
            style={{ height: '140px', overflow: 'hidden', cursor: 'pointer', position: 'relative' }}
            onClick={handleClick}
         >
            {loading ? (
               <div className="spinner-border spinner-border-sm text-primary"></div>
            ) : foto ? (
               <img src={`data:image/jpeg;base64,${foto}`} className="img-fluid" style={{ height: '100%', width: '100%', objectFit: 'cover' }} alt={titulo} />
            ) : (
               <div className="text-muted small text-center px-2">
                  <i className={`fa ${isEditable ? 'fa-camera' : 'fa-image'} d-block mb-1 opacity-50`} style={{ fontSize: '24px' }}></i>
                  {isEditable ? 'TIRAR FOTO' : 'SEM FOTO'}
               </div>
            )}
         </div>
         {isEditable && (
            <input
               type="file" accept="image/*" capture="environment"
               ref={fileInputRef} style={{ display: 'none' }}
               onChange={(e) => onFileSelect(e.target.files[0])}
            />
         )}
      </div>
   );
};

// =========================
// COMPONENTE PRINCIPAL
// =========================
const VistoriaResposta = () => {
   const { token } = useParams();
   const navigate = useNavigate();
   const [vistoria, setVistoria] = useState(null);
   const [itens, setItens] = useState([]);
   const [loading, setLoading] = useState(false);
   const [zoomImg, setZoomImg] = useState(null);

   // Decodificação robusta para UTF-8/Base64 do Oracle
   const decodeBase64 = (str) => {
      if (!str || str === "null") return "";
      try {
         return decodeURIComponent(escape(window.atob(str.trim())));
      } catch (e) {
         return str;
      }
   };

   useEffect(() => {
      if (!localStorage.getItem("chapa")) {
         navigate(`/?origem=vistoria-execucao&token=${token}`);
         return;
      }
      if (token) carregarDados();
   }, [token]);

   const carregarDados = async () => {
      setLoading(true);
      try {
         const res = await api.get(`/vistoria/token/${token}`);
         if (res.data && res.data.cabecalho) {
            setVistoria(res.data.cabecalho);

            // TRATAMENTO DOS DADOS: Decodifica descrição e observação
            const itensTratados = (res.data.itens || []).map(it => ({
               ...it,
               descricao_ponto: decodeBase64(it.descricao_ponto),
               obs_gerente: decodeBase64(it.obs_gerente)
            }));

            setItens(itensTratados);
         }
      } catch (err) {
         Swal.fire('Erro', 'Falha ao carregar vistoria.', 'error');
      } finally {
         setLoading(false);
      }
   };

   const responderItem = async (item, arquivoFoto = null) => {
      const { value: obs } = await Swal.fire({
         title: 'Responder Item',
         html: `<textarea id="swal-obs" class="form-control" rows="4" placeholder="Descreva a solução...">${item.obs_gerente || ''}</textarea>`,
         showCancelButton: true,
         confirmButtonText: 'Salvar Resposta',
         preConfirm: () => document.getElementById('swal-obs').value
      });

      if (obs !== undefined) {
         processarEnvio(item, obs, arquivoFoto);
      }
   };

   // No arquivo respondervistoria.jsx, dentro da função processarEnvio:

   const processarEnvio = async (item, obs, file) => {
      // ... validações existentes ...

      const chapaGerente = localStorage.getItem("chapa"); // Pega o ID do gerente logado

      setLoading(true);
      try {
         let fotoBase64 = "";
         if (file) {
            const reader = new FileReader();
            fotoBase64 = await new Promise((resolve) => {
               reader.onload = () => resolve(reader.result.split(',')[1]);
               reader.readAsDataURL(file);
            });
         }

         await api.put('/vistoria/executar', {
            id_item: item.id_item,
            id_vistoria: vistoria.id_vistoria, // Verifique se o objeto 'vistoria' está carregado
            obs: obs,
            foto: fotoBase64,
            id_gerente: localStorage.getItem("chapa")
         });

         Swal.fire('Sucesso', 'Resposta salva!', 'success');
         carregarDados();
      } catch (err) {
         Swal.fire('Erro', 'Não foi possível salvar.', 'error');
         console.error(err);
      } finally {
         setLoading(false);
      }
   };

   return (
      <>
         <Menu modulo="ARBOR"/>
         <div className="container mt-4" style={{ paddingTop: '75px', marginBottom: '100px' }}>
            {vistoria && (
               <div className="card border-0 shadow-sm mb-4" style={{ borderLeft: '5px solid #0056b3' }}>
                  <div className="card-body py-2">
                     <h6 className="fw-bold mb-0" style={{ color: '#0056b3' }}>Vistoria #{vistoria.id_vistoria}</h6>
                     <small className="text-muted">{vistoria.razao}</small>
                  </div>
               </div>
            )}

            <div className="row">
               {itens.map(item => (
                  <div className="col-12 mb-3" key={item.id_item}>
                     <div className="card border-0 shadow-sm">
                        <div className="card-body">
                           <div className="d-flex justify-content-between mb-2">
                              <span className="badge bg-light text-dark border small">{item.tipo}</span>
                              <span className={`small fw-bold ${item.status_item === 'EXECUTADO' ? 'text-success' : 'text-warning'}`}>
                                 {item.status_item === 'EXECUTADO' ? '● CONCLUÍDO' : '○ PENDENTE'}
                              </span>
                           </div>

                           <p className="mb-3 fw-bold">{item.descricao_ponto}</p>

                           <div className="row g-2 mb-3">
                              <div className="col-6">
                                 <FotoItem idItem={item.id_item} tipoFoto="antes" titulo="ANTES" onZoom={setZoomImg} />
                              </div>
                              <div className="col-6">
                                 <FotoItem
                                    idItem={item.id_item} tipoFoto="depois" titulo="SOLUÇÃO"
                                    onZoom={setZoomImg} isEditable={item.status_item !== 'EXECUTADO'}
                                    onFileSelect={(file) => responderItem(item, file)}
                                 />
                              </div>
                           </div>

                           {item.obs_gerente && (
                              <div className="p-2 mb-3 small bg-light border-start border-3 border-success">
                                 <strong>Solução aplicada:</strong><br />{item.obs_gerente}
                              </div>
                           )}

                           {item.status_item !== 'EXECUTADO' && (
                              <button className="btn btn-primary w-100 fw-bold shadow-sm"
                                 style={{ backgroundColor: '#0056b3' }}
                                 onClick={() => responderItem(item)}>
                                 <i className="fa fa-edit me-2"></i>RESPONDER
                              </button>
                           )}
                        </div>
                     </div>
                  </div>
               ))}
            </div>
         </div>

         {/* MODAL ZOOM */}
         {zoomImg && (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(0,0,0,0.9)', zIndex: 10000, display: 'flex', alignItems: 'center', justifyContent: 'center' }}
               onClick={() => setZoomImg(null)}>
               <img src={zoomImg} style={{ maxWidth: '98%', maxHeight: '98%', borderRadius: '4px' }} alt="Zoom" />
            </div>
         )}

         {/* MODAL LOADING */}
         {loading && (
            <div style={{ position: 'fixed', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255,255,255,0.7)', zIndex: 9999, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
               <div className="spinner-border text-primary"></div>
            </div>
         )}
         <Footer />
      </>
   );
};

export default VistoriaResposta;